import { render, staticRenderFns } from "./UpgradeProgress.vue?vue&type=template&id=8225e74e&"
import script from "./UpgradeProgress.vue?vue&type=script&lang=js&"
export * from "./UpgradeProgress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports